/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $NotifyOnEmployeeDocumentResponse = {
    type: 'array',
    contains: {
        type: 'NotifyOnEmployeeDocument',
    },
};